import { useDispatch, useSelector } from "react-redux";
import EditHeight from "../../../components/EditHeight";
import { RootState } from "../../../redux/store";
import { setSignupData } from "../../../redux/signup";

const SelectHeightQuestion = (props: any) => {
    const dispatch = useDispatch();
    const register = useSelector((state: RootState) => state.signup);
    const question = useSelector((state: RootState) => state.signupQuestions.questions?.filter(x => x.questionId === 3030)).pop()!;

    const onSave = (selectedHeight: number) => {
        register.height = selectedHeight;
        dispatch(setSignupData(register));
        props.next();
    }
    return (
        <>
            <EditHeight buttonText={"אפשר להמשיך"} onSave={onSave} subtitle={question.questionSubTitle!} title={question.question} />
        </>
    )
}

export default SelectHeightQuestion;